var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildTitle, buildStandardMeta, buildOgMeta, buildLink, buildOgMetaRefs, buildTwitterMetaRefs, } from '../../types/builders';
import adapter from './adapter-blog-archive';
import { siteIDs } from '../../adapters/utils';
var IDs = adapter.IDs;
var SITE_NAME = siteIDs.SITE_NAME;
var MONTH_NAME = IDs.MONTH_NAME, YEAR = IDs.YEAR, URL = IDs.URL, PREV_URL = IDs.PREV_URL, NEXT_URL = IDs.NEXT_URL;
export var BLOG_ARCHIVE = {
    tags: __spreadArrays([
        buildTitle("{{" + MONTH_NAME + "}} - {{" + YEAR + "}}"),
        buildStandardMeta('robots', 'noindex'),
        buildLink('canonical', "{{" + URL + "}}")
    ], buildOgMetaRefs(), [
        buildOgMeta('og:url', "{{" + URL + "}}"),
        buildOgMeta('og:site_name', "{{" + SITE_NAME + "}}"),
        buildOgMeta('og:type', 'website'),
        buildLink('prev', "{{" + PREV_URL + "}}"),
        buildLink('next', "{{" + NEXT_URL + "}}")
    ], buildTwitterMetaRefs()),
};
